import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import CancelButton from "presentation/components/buttons/cancel";

import TimesheetStrcutureItems from 'presentation/pages/timesheet-structures/elements/timesheet-structure-items';

import { handleChange, isoDayOfWeekList } from "presentation/utils/functions/generic";

import { handleSubmit } from 'presentation/pages/timesheet-structures/functions/timesheet-structures';

class TimesheetStructureForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localLoading: false,
            localError: false,
            message: '',
            topics: []
        }
    }

    dayOfWeekIsSelected = (dayOfWeek) => {
        const { component } = this.props;
        const { rawDaysOfWeek } = component.state;

        return rawDaysOfWeek.includes(dayOfWeek);
    }

    selectDayOfWeek = (event, dayOfWeek) => {
        const { component } = this.props;
        let { rawDaysOfWeek } = component.state;

        let isSelected = event.target.checked;
        var newDaysOfWeekStage = [];

        if (isSelected) {
            if (!rawDaysOfWeek.includes(dayOfWeek)) {
                newDaysOfWeekStage = rawDaysOfWeek;
                newDaysOfWeekStage.push(dayOfWeek);

            }
        } else {
            newDaysOfWeekStage = rawDaysOfWeek.filter(x => x != dayOfWeek);
        }
        component.setState({ rawDaysOfWeek: newDaysOfWeekStage });
    }

    render() {
        const { dayOfWeekIsSelected, selectDayOfWeek } = this;
        var { localLoading, localError, message } = this.state;
        var { loading, form, component } = this.props;
        var daysOfWeek = isoDayOfWeekList();

        return (
            <>
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Form className="mb-5">
                            <h5>Informações da estrutura</h5>
                            <div className="form">
                                <Form.Label htmlFor="name">Nome</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="name"
                                    name="name"
                                    defaultValue={form.name}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="nameHelpBlock"
                                />
                                <Form.Text id="nameHelpBlock" muted>
                                    Informe o nome da estrutura
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="displayName">Dias da semana</Form.Label>
                                <div className="mb-3 mt-3">
                                    {daysOfWeek.map((isoItem) => (
                                        <Form.Check
                                            key={isoItem.dayOfWeek}
                                            inline
                                            label={isoItem.name}
                                            name="rawDayOfWeek"
                                            type={'checkbox'}
                                            checked={dayOfWeekIsSelected(isoItem.dayOfWeek)}
                                            onChange={(e) => selectDayOfWeek(e, isoItem.dayOfWeek)}
                                            id={`inline-iso-${isoItem.dayOfWeek}`}
                                        />
                                    ))}
                                </div>
                                <Form.Text id="codeHelpBlock" muted>
                                    Escolha em quais dias da semana essa estrutura tem atividades
                                </Form.Text>
                            </div>
                            <div className="mt-3">
                                <TimesheetStrcutureItems component={component} />
                            </div>
                            <div className="mt-3">
                                <CancelButton
                                    containerProps={{
                                        as: Link,
                                        to: `/estruturas-quadro-de-horarios`
                                    }}
                                />
                                <Button disabled={loading || localError} variant="success" className="float-end" onClick={() => handleSubmit(component)}>Salvar</Button>
                            </div>
                        </Form>
                    )
                }
            </>
        );
    };
}

export default TimesheetStructureForm;